import Vue from 'vue'
import store from 'store'

export default (el) => Promise.all([]).then(() => new Vue({
  el,
  store,
  data () {
    return {
      isActive: false,
      show: false,
      announcementBlocks: [],
      currentIndex: 0
    }
  },
  mounted () {
    if (!this.$el || !this.$el.dataset) return

    this.announcementBlocks = this.$el.dataset.blocks
      ? JSON.parse(this.$el.dataset.blocks)
      : []

    if (this.$el.dataset.active) {
      this.isActive = this.$el.dataset.active
    }

    this.startCarousel()

    if (this.isActive === 'true') {
      this.show = true
    }

    this.syncAnnouncementOffset(this.show)
  },
  beforeDestroy () {
    clearInterval(this.carouselInterval)
  },
  methods: {
    syncAnnouncementOffset (isVisible) {
      const announcementHeight = isVisible
        ? `${(this.$el.dataset.announcementHeight || 45) / 10}rem`
        : '0px'

      document.documentElement.style.setProperty('--redesign-announcement-height', announcementHeight)
      document.body.classList.toggle('redesign-announcement-hidden', !isVisible)

      const header = document.querySelector('.js-header')

      if (header) {
        header.classList.toggle('top-banner-hide', !isVisible)
      }
    },
    // Method to close the announcement banner
    close () {
      this.show = false
      this.syncAnnouncementOffset(false)
    },
    startCarousel () {
      if (this.announcementBlocks.length <= 1) return

      this.carouselInterval = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.announcementBlocks.length
      }, 4000)
    }
  }
}))
